module.exports = __webpack_public_path__ + "img/canada-gc-3.c2f94565.png";